import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {
  ExcludeOutliersValues,
  POINT_VISUALIZATION_OPTIONS,
  PointVisualizationOptions,
} from '../../WorkspaceDrawer/Settings/types';
import {
  createBooleanDisplayFn,
  createEnumDisplayFn,
} from '../displayValueFactory';
import {mappedBooleanDisplayValue} from '../utils';

const excludeOutliersLabels: Record<ExcludeOutliersValues, string> = {
  'include-outliers': 'Include outliers',
  'exclude-outliers': 'Exclude outliers',
};

const pointVisualizationLabels: Record<PointVisualizationOptions, string> = {
  [POINT_VISUALIZATION_OPTIONS.BucketingGorilla]: 'Full fidelity',
  [POINT_VISUALIZATION_OPTIONS.Sampling]: 'Sampling',
  [POINT_VISUALIZATION_OPTIONS.SamplingByDefault]: 'Sampling (default)',
};

export const getExcludeOutliersDisplayRow = createEnumDisplayFn({
  field: 'excludeOutliers',
  label: 'Outliers',
  groupTitle: 'Data',
  formatter: value => excludeOutliersLabels[value] ?? value,
});

export const getPointVisualizationMethodDisplayRow = createEnumDisplayFn({
  field: 'pointVisualizationMethod',
  label: 'Point aggregation',
  groupTitle: 'Data',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.pointVisualizationMethod,
  formatter: value => pointVisualizationLabels[value] ?? value,
});

export const getShowOriginalAfterSmoothingDisplayRow = createBooleanDisplayFn({
  field: 'showOriginalAfterSmoothing',
  label: 'Show original after smoothing',
  groupTitle: 'Smoothing',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.showOriginalAfterSmoothing,
  formatter: mappedBooleanDisplayValue,
});
